import FormType from "../../../../../Components/Form/FormType";
import Url from "../../../../../Services/Url";

const EditTemplateOptions = (showCompanyField = false) => {
	const Fields = [
		[
			{
				element: FormType.Input,
				type: "text",
				name: "name",
				label: "Name",
				placeholder: "Repair ICOMS",
				value: null,
			},
			{
				element: FormType.Select,
				name: "type",
				label: "Task Type",
				placeholder: "Select Type",
				value: null,
				options: { url: Url.taskType },
			},
		],
		[
			{
				element: FormType.TextArea,
				name: "use_case",
				label: "Use case",
				value: null,
			},
		],
	];

	// Conditionally add the company field if toggle is ON
	if (showCompanyField) {
		Fields.push([
			{
				element: FormType.Select,
				name: "entCompanyId",
				label: "Milestone Company",
				placeholder: "Select Company",
				required: true,
				value: null,
				options: {
					url: Url.enterpriseCompany.allCompany,
					id: "id",
					name: "name",
				},
			},
		]);
	}

	return { Fields };
};

export default EditTemplateOptions;
